import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import robotoStyles from "../fonts/RobotoFont.styles";
import overpassStyles from "../fonts/OverpassFont.styles";
import barlowStyles from "../fonts/BarlowFont.styles";
import printableStyles from "../styles/Printable.styles";

const Printable = ({
	showPreview,
	children,
	onBeforeGetContent,
	onBeforePrint,
	onAfterPrint,
	fileName
}) => {
	const classes = printableStyles();
	robotoStyles();
	overpassStyles();
	barlowStyles();

	const boxScoreRef = useRef();

	const doPrint = useReactToPrint({
		content: () => boxScoreRef.current,
		onBeforeGetContent,
		onBeforePrint,
		onAfterPrint,
		documentTitle: fileName
	});

	useEffect(() => {
		if (showPreview) {
			doPrint();
		}
	}, [showPreview]);

	return showPreview ? (
		<div ref={boxScoreRef} className={classes.printOnly}>
			{children}
		</div>
	) : null;
};

export default Printable;
